// src/components/layout/TopBar.tsx
import { useNavigate } from "react-router-dom";

type Props = {
  /** Текущее количество искорок. Если null/undefined — покажем «--». */
  xp: number | null | undefined;
  /** Открыть модалку кошелька. */
  onOpenWallet: () => void;
  /** Авторизован ли пользователь. */
  isAuthenticated: boolean;
};

/**
 * Сквозная верхняя шапка. Фиксирована, с блюром и тонкой границей.
 * Высота контента шапки — 56px (h-14). Учитываем «чёлку» через paddingTop: env(safe-area-inset-top).
 *
 * ❗️Важно: цель для полёта искорок — #wallet-pill (не меняйте id).
 */
export default function TopBar({ xp, onOpenWallet, isAuthenticated }: Props) {
  const navigate = useNavigate();
  const displayXp =
    typeof xp === "number" && Number.isFinite(xp) ? xp.toLocaleString("ru-RU") : "--";

  return (
    <header
      role="banner"
      className="fixed top-0 inset-x-0 z-[100] border-b border-gray-200 bg-white/80 backdrop-blur supports-[backdrop-filter]:bg-white/60"
      style={{ paddingTop: "env(safe-area-inset-top)" }}
    >
      <div className="h-14">
        <div className="max-w-5xl mx-auto w-full px-4 h-full flex items-center justify-end">
          {isAuthenticated ? (
            <button
              id="wallet-pill"
              type="button"
              aria-label="Баланс искорок"
              title="Искорки — внутренняя валюта"
              onClick={onOpenWallet}
              className="inline-flex items-center gap-2 px-5 h-9 rounded-full
                         border border-white/15 bg-[#0B0E19] text-white
                         hover:opacity-90 focus:outline-none focus:ring-2 focus:ring-white/30
                         transition shadow-[0_8px_24px_rgba(11,14,25,0.25)]
                         min-w-[132px] sm:min-w-[160px] justify-center"
            >
              <span className="text-base leading-none">✨</span>
              <span className="text-sm font-semibold tabular-nums">{displayXp}</span>
              <span className="text-xs text-white/70 hidden xs:inline">искорок</span>
            </button>
          ) : (
            <button
              type="button"
              onClick={() => navigate("/auth/otp")}
              className="inline-flex items-center justify-center px-5 h-9 rounded-full
                         bg-[#0B0E19] text-white text-sm font-semibold
                         hover:opacity-90 focus:outline-none focus:ring-2 focus:ring-white/30
                         transition shadow-[0_8px_24px_rgba(11,14,25,0.25)]
                         min-w-[132px] sm:min-w-[160px]"
            >
              Войти
            </button>
          )}
        </div>
      </div>
    </header>
  );
}
